export default "__VITE_ASSET__CGSohEho__"